import { render } from "./EatingStatus.vue?vue&type=template&id=4a997512&scoped=true&ts=true"
import script from "./EatingStatus.vue?vue&type=script&lang=ts"
export * from "./EatingStatus.vue?vue&type=script&lang=ts"

import "./EatingStatus.vue?vue&type=style&index=0&id=4a997512&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a997512"]])

export default __exports__